import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';

/*
 * Constants.
 */

export const contactSalesEmailAddress = 'accountservices@front.com';

interface ContactSalesButtonProps {
  className?: string;
  variant?: ButtonVariantsEnum;
}

/*
 * Component.
 */

export const ContactSalesButton: FC<ContactSalesButtonProps> = ({className, variant}) => (
  <a href={`frontapp-mailto:${contactSalesEmailAddress}`} className={className}>
    <Button variant={variant ?? ButtonVariantsEnum.PRIMARY}>
      <Trans id="upsell-button-contact-sales">Contact Sales</Trans>
    </Button>
  </a>
);
